import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import Axios from 'axios';
import Moment from 'moment';

import * as Antd from 'antd';
import * as AntdIcons from '@ant-design/icons';
import * as SYS from '.';

export const UserGrid = forwardRef((props, ref) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [actionFormInit, setPageFormInit] = useState(null);

    const fetchData = async () => {
        try {
            let dataResponse = await Axios.get(`${process.env.REACT_APP_API_BASE_URI}/api/users`);
            return dataResponse.data;
        } catch (err) {
            console.log(err);
        }
    }

    const init = async () => {
        setLoading(true);
        let d = await fetchData();
        setData(d);
        setLoading(false);
    }

    const onFormSuccess = async (values) => {
        try {
            if (values.id) {
                let id = values.id;
                delete values.id;
                await Axios.patch(`${process.env.REACT_APP_API_BASE_URI}/api/users/${id}`, values);
            } else {
                await Axios.post(`${process.env.REACT_APP_API_BASE_URI}/api/users`, values);
            }
            await init();
        } catch (err) {
            console.log(err);
        }
    }

    const onDeleteItem = async (id) => {
        try {
            await Axios.delete(`${process.env.REACT_APP_API_BASE_URI}/api/users/${id}`);
            await init();
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        init();
    }, []);

    useImperativeHandle(ref, () => ({
        init: init,
        setPageFormInit: setPageFormInit,
    }));

    return (
        <>
            {props.showActions
                ? <Antd.Space
                    style={{
                        marginBottom: 10,
                        float: 'right',
                    }}
                >
                    <Antd.Button
                        icon={<AntdIcons.ReloadOutlined />}
                        title="Reload"
                        disabled={loading}
                        onClick={() => {
                            init();
                        }}
                    />
                    <Antd.Button
                        icon={<AntdIcons.PlusOutlined />}
                        title="Create new"
                        disabled={loading}
                        onClick={() => {
                            setPageFormInit({});
                        }}
                    />
                </Antd.Space>
                : null}
            <Antd.Table
                size={'small'}
                loading={loading}
                dataSource={data}
                rowKey={'id'}
                pagination={{
                    defaultPageSize: 50,
                    showSizeChanger: true,
                }}
                expandable={{
                    expandedRowRender: (record) => (
                        <Antd.Card
                            title="Additionals"
                        >
                            <Antd.Descriptions
                                bordered
                                size="small"
                            >
                                {Object.keys(record.additionals).map((key) => (
                                    <Antd.Descriptions.Item label={key}>{record.additionals[key]}</Antd.Descriptions.Item>
                                ))}
                            </Antd.Descriptions>
                        </Antd.Card>
                    )
                }}
            >
                <Antd.Table.Column
                    key='username'
                    dataIndex='username'
                    title='Username'
                    width={130}
                />
                <Antd.Table.Column
                    key='lastName'
                    dataIndex='lastName'
                    title='Last name'
                    width={130}
                />
                <Antd.Table.Column
                    key='firstName'
                    dataIndex='firstName'
                    title='First name'
                    width={130}
                />
                <Antd.Table.Column
                    key='roles'
                    dataIndex='roles'
                    title='Roles'
                    width={250}
                    render={(value, record) => (record.roles.map(child => <Antd.Tag>{child}</Antd.Tag>))}
                />
                <Antd.Table.Column
                    key='lastLoggedAt'
                    dataIndex='lastLoggedAt'
                    title='Last logged at'
                    width={150}
                    render={(value, record) => value ? Moment(value).format('LLL') : 'n/a'}
                />
                <Antd.Table.Column
                    key='createdAt'
                    dataIndex='createdAt'
                    title='Created at'
                    width={150}
                    render={(value, record) => Moment(value).format('LLL')}
                />
                <Antd.Table.Column
                    key='action'
                    title='Action'
                    width={100}
                    render={(value, record) => (
                        <Antd.Space
                            size="middle"
                        >
                            <a
                                onClick={() => {
                                    setPageFormInit(record);
                                }}
                            >
                                Edit
                            </a>
                            <Antd.Popconfirm
                                placement="topLeft"
                                title="Do you really want to delete the entry?"
                                okText="Yes"
                                cancelText="No"
                                onConfirm={() => {
                                    onDeleteItem(record.id);
                                }}
                            >
                                <a>
                                    Delete
                                </a>
                            </Antd.Popconfirm>
                        </Antd.Space>
                    )}
                />
            </Antd.Table>
            <Antd.Drawer
                title={actionFormInit && actionFormInit.id
                    ? 'Edit user'
                    : 'Create new user'}
                width={1200}
                visible={actionFormInit !== null
                    ? true
                    : false}
                closable={true}
                onClose={() => setPageFormInit(null)}
            >
                {actionFormInit
                    ? <SYS.UserForm
                        initialValues={actionFormInit}
                        onSuccess={onFormSuccess}
                    />
                    : null}
            </Antd.Drawer>
        </>
    )
})